/**
 * Utility functions for Shadow DOM operations
 */

export const injectStylesIntoShadow = (
  shadowRoot: ShadowRoot,
  cssContent: string,
): HTMLStyleElement => {
  const style = document.createElement("style");
  style.textContent = cssContent;
  shadowRoot.appendChild(style);
  return style;
};

export interface ShadowDOMStructureConfig {
  sheetClasses: string;
  contentClasses: string;
  sheetStyle?: React.CSSProperties;
}

export interface ShadowDOMStructure {
  shadowRoot: ShadowRoot;
  sheetContainer: HTMLDivElement;
  contentContainer: HTMLDivElement;
}

export const createShadowDOMStructure = (
  container: HTMLElement,
  cssContent: string,
  config: ShadowDOMStructureConfig,
): ShadowDOMStructure => {
  const shadowRoot = container.attachShadow({ mode: "closed" });

  injectStylesIntoShadow(shadowRoot, cssContent);

  // Create sheet container
  const sheetContainer = document.createElement("div");
  sheetContainer.className = config.sheetClasses;
  if (config.sheetStyle) {
    Object.assign(sheetContainer.style, config.sheetStyle);
  }
  sheetContainer.setAttribute("role", "dialog");
  sheetContainer.setAttribute("aria-modal", "true");

  const contentContainer = document.createElement("div");
  contentContainer.className = config.contentClasses;

  // Assemble structure: contentContainer -> sheetContainer -> shadowRoot
  sheetContainer.appendChild(contentContainer);
  shadowRoot.appendChild(sheetContainer);

  return { shadowRoot, sheetContainer, contentContainer };
};
